/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { useEffect } from "react";

/**
 * Subscribes to the current contact events
 * @param connectEvent the amazon connect event to listen to
 * @param callback the callback to call when the event happens
 */
export const useCurrentContactEvents = (connectEvent, callback) => {
	useEffect(() => {
		const bus = window.connect.core.getEventBus();
		const subscription = bus.subscribe(connectEvent, (contact) => {
			if (!callback || typeof callback !== "function") {
				throw new Error("Callback must be a function");
			} else {
				callback(contact);
			}
		});

		return () => {
			subscription.unsubscribe();
		};
	}, [connectEvent, callback]);
};
